import axios from 'axios'
import {config} from '../config'
export const getWishList = () =>{
    return axios.get(config.wishlist)
    .then(function (response) {
        return response
    })
    .catch(function (error) {
      console.log(error);
    })
}

